import api from 'api'

export interface PendingEvereePayment {
  id: number
  userId: number
  userName?: string | null
  shiftId: number | null
  amount: string | number
  status: string
  paymentProvider: string
  createdAt: string
}

export async function getPendingEvereePayments(): Promise<
  PendingEvereePayment[]
> {
  const resp = await api.get('/admin/w2/payments/pending')
  return resp.data as PendingEvereePayment[]
}
